import React from 'react'

export interface TrProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children?: React.ReactNode
  /**
   * columnsSize as fr -> ie: '1fr 3fr'
   */
  columnsSize: string
}

const Tr = React.forwardRef<HTMLTableRowElement, TrProps>(
  ({ children, className, columnsSize, ...rest }, ref) => {
    return (
      <tr
        ref={ref}
        style={{ gridTemplateColumns: columnsSize }}
        {...rest}
        className={`grid bg-gray-50 odd:bg-white ${
          className || ''
        } overflow-hidden overflow-ellipsis whitespace-nowrap`}
      >
        {children}
      </tr>
    )
  }
)

export default Tr
